/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BadRequestErrorResponse,
    BadRequestErrorResponseFromJSON,
    BadRequestErrorResponseToJSON,
    ConflictErrorResponse,
    ConflictErrorResponseFromJSON,
    ConflictErrorResponseToJSON,
    JobResponse,
    JobResponseFromJSON,
    JobResponseToJSON,
    JobStatusType,
    JobStatusTypeFromJSON,
    JobStatusTypeToJSON,
    JobsResponse,
    JobsResponseFromJSON,
    JobsResponseToJSON,
    NotFoundErrorResponse,
    NotFoundErrorResponseFromJSON,
    NotFoundErrorResponseToJSON,
} from '../models';

export interface DeleteJobRequest {
    id: string;
}

export interface ReadJobRequest {
    id: string;
}

export interface ReadJobInputRequest {
    id: string;
}

export interface ReadJobRejectionRequest {
    id: string;
}

export interface ReadJobReportRequest {
    id: string;
}

export interface ReadJobsRequest {
    filter?: string | null;
    offset?: number | null;
    limit?: number | null;
}

export interface UpdateJobStatusRequest {
    id: string;
    body: string;
}

/**
 * 
 */
export class JobsApi extends runtime.BaseAPI {

    /**
     * Delete job by ID.
     */
    async deleteJobRaw(requestParameters: DeleteJobRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteJob.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jobs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete job by ID.
     */
    async deleteJob(requestParameters: DeleteJobRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteJobRaw(requestParameters, initOverrides);
    }

    /**
     * Delete jobs.
     */
    async deleteJobsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jobs`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete jobs.
     */
    async deleteJobs(initOverrides?: RequestInit): Promise<void> {
        await this.deleteJobsRaw(initOverrides);
    }

    /**
     * Read job by ID.
     */
    async readJobRaw(requestParameters: ReadJobRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<JobResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readJob.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jobs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobResponseFromJSON(jsonValue));
    }

    /**
     * Read job by ID.
     */
    async readJob(requestParameters: ReadJobRequest, initOverrides?: RequestInit): Promise<JobResponse> {
        const response = await this.readJobRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read job input by ID.
     */
    async readJobInputRaw(requestParameters: ReadJobInputRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readJobInput.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jobs/{id}/input`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Read job input by ID.
     */
    async readJobInput(requestParameters: ReadJobInputRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.readJobInputRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read job rejection by ID.
     */
    async readJobRejectionRaw(requestParameters: ReadJobRejectionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readJobRejection.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jobs/{id}/rejection`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Read job rejection by ID.
     */
    async readJobRejection(requestParameters: ReadJobRejectionRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.readJobRejectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read job report by ID.
     */
    async readJobReportRaw(requestParameters: ReadJobReportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readJobReport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jobs/{id}/report`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Read job report by ID.
     */
    async readJobReport(requestParameters: ReadJobReportRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.readJobReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read jobs.
     */
    async readJobsRaw(requestParameters: ReadJobsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<JobsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jobs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobsResponseFromJSON(jsonValue));
    }

    /**
     * Read jobs.
     */
    async readJobs(requestParameters: ReadJobsRequest = {}, initOverrides?: RequestInit): Promise<JobsResponse> {
        const response = await this.readJobsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update job status flag by ID. NOTE the only currently supported status is CANCELLED.
     */
    async updateJobStatusRaw(requestParameters: UpdateJobStatusRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateJobStatus.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling updateJobStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jobs/{id}/status`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update job status flag by ID. NOTE the only currently supported status is CANCELLED.
     */
    async updateJobStatus(requestParameters: UpdateJobStatusRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateJobStatusRaw(requestParameters, initOverrides);
    }

}
